<!-- @veltra/icons generated sha256:e2469342df8b847d gen:8 source:src/svg/normal/qr-code.svg -->
<script setup lang="ts">
defineOptions({ name: 'QrCode' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2.5 2a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5zm8 0a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM3 3h4v4H3zm10 2h-2V3h2zM6 4H4v2h2zm7.5 3.5h-3c-.275 0-.5.209-.5.485v.011c0 .276.225.504.5.504h3c.275 0 .5-.209.5-.485v-.011a.504.504 0 0 0-.5-.504m-5 1.996A.505.505 0 0 0 7.996 9a.505.505 0 0 0-.496.504c0 .268.228.496.504.496a.505.505 0 0 0 .496-.504M2.5 10a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm8 0a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM3 13v-2h2v2zm5.5-1.488v1.976a.513.513 0 0 1-.504.512.51.51 0 0 1-.496-.512v-1.976c0-.277.228-.512.504-.512.268 0 .496.235.496.512M13 13h-2v-2h2z"
    />
  </svg>
</template>
